/* =========================================================
   Solaci Sticky Gallery v14.1b (stable sticky) — FIXED TOP GAP
   - stop marker (normal flow) so it stops cleanly at tabs
   - no shift-right
   - STOP_PAD tuned for alignment: -16
   - FIX: remove forced 50px minimum top offset (caused white gap)
   - FIX: don’t “pin” at scrollY=0
   ========================================================= */
(() => {
  if (window.__solaciStickyV141b) return;
  window.__solaciStickyV141b = true;

  const MIN_WIDTH = 990;
  const EXTRA_GAP = 10;
  const STOP_PAD  = -16;

  const $  = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const isDesktop = () => window.innerWidth >= MIN_WIDTH;

  function isProductPage() {
    const b = document.body;
    if (!b) return false;
    return b.classList.contains("template-product") || /product/i.test(b.className || "");
  }

  function findLeft() {
    return $(".product__images.three-fifths") || $(".product__images") || $(".product_gallery");
  }

  function findTabsAnchor() {
    return (
      $(".station-tabs") ||
      $(".product-tabs") ||
      $(".product_tabs") ||
      $(".product__tabs") ||
      $("#tabs") ||
      $(".tabs") ||
      document.querySelector('[role="tablist"]')
    );
  }

  // stop marker inserted in NORMAL FLOW (before sticky/fixed tabs container)
  let stopMarker = null;

  function getStopMarker() {
    if (stopMarker && document.contains(stopMarker)) return stopMarker;

    const tabs = findTabsAnchor();
    if (!tabs || !tabs.parentNode) return null;

    let target = tabs;
    let p = tabs;
    while (p && p !== document.body) {
      const pos = getComputedStyle(p).position;
      if (pos === "sticky" || pos === "fixed") {
        target = p;
        break;
      }
      p = p.parentElement;
    }

    stopMarker = document.createElement("div");
    stopMarker.id = "solaci-sticky-stop-marker";
    stopMarker.style.height = "0px";
    stopMarker.style.margin = "0";
    stopMarker.style.padding = "0";
    stopMarker.style.border = "0";
    stopMarker.style.pointerEvents = "none";

    target.parentNode.insertBefore(stopMarker, target);
    return stopMarker;
  }

  function getTopOffset() {
    const selectors = [
      ".promo-banner", ".announcement-bar", ".top-bar",
      "#shopify-section-announcement-bar", "#shopify-section-header",
      ".header", ".site-header", ".header-wrapper", ".header__wrapper", "#header"
    ];

    let maxBottom = 0;

    selectors.forEach(sel => {
      $$(sel).forEach(el => {
        const cs = getComputedStyle(el);
        if (cs.display === "none" || cs.visibility === "hidden") return;
        if (cs.position !== "fixed" && cs.position !== "sticky") return;

        const r = el.getBoundingClientRect();

        // Only count bars that are actually occupying the top (not translated off-screen)
        if (r.bottom > 0 && r.top > -1 && r.top < 80) {
          maxBottom = Math.max(maxBottom, r.bottom);
        }
      });
    });

    // ✅ IMPORTANT: no forced minimum (this is what was creating the white gap)
    return Math.max(0, Math.round(maxBottom + EXTRA_GAP));
  }

  function setImp(el, prop, value) { el.style.setProperty(prop, value, "important"); }
  function clearImp(el, prop) { el.style.removeProperty(prop); }

  function boot() {
    if (!isProductPage() || !isDesktop()) return false;

    const left = findLeft();
    if (!left || !left.parentNode) return false;

    getStopMarker();

    let stuck = false;
    let ph = null;
    let lastLeft = 0;
    let lastW = 0;

    const originalInlineMargins = {
      ml: left.style.marginLeft,
      mr: left.style.marginRight,
      mt: left.style.marginTop,
      mb: left.style.marginBottom,
    };

    function createPlaceholder() {
      if (ph) return;
      ph = document.createElement("div");
      ph.className = (left.className || "") + " solaci-sticky-ph";
      ph.style.visibility = "hidden";
      ph.style.pointerEvents = "none";
      ph.style.height = left.offsetHeight + "px";
      ph.style.minHeight = left.offsetHeight + "px";
      left.parentNode.insertBefore(ph, left);
    }

    function updatePlaceholder() {
      if (!ph) return;
      const h = left.offsetHeight;
      ph.style.height = h + "px";
      ph.style.minHeight = h + "px";
    }

    function forceFixedMarginsOff() {
      setImp(left, "margin-left", "0px");
      setImp(left, "margin-right", "0px");
      setImp(left, "margin-top", "0px");
      setImp(left, "margin-bottom", "0px");
    }

    function restoreMargins() {
      left.style.marginLeft   = originalInlineMargins.ml;
      left.style.marginRight  = originalInlineMargins.mr;
      left.style.marginTop    = originalInlineMargins.mt;
      left.style.marginBottom = originalInlineMargins.mb;
    }

    function pin() {
      createPlaceholder();
      updatePlaceholder();

      const top = getTopOffset();
      const r = ph.getBoundingClientRect();

      left.classList.add("solaci-sticky-active");

      setImp(left, "position", "fixed");
      setImp(left, "top", `${top}px`);
      setImp(left, "left", `${r.left}px`);
      setImp(left, "width", `${r.width}px`);
      setImp(left, "z-index", "20");
      setImp(left, "box-sizing", "border-box");

      forceFixedMarginsOff();

      stuck = true;
      lastLeft = r.left;
      lastW = r.width;
    }

    function reset() {
      left.classList.remove("solaci-sticky-active");

      [
        "position","top","left","width","z-index","box-sizing","transform",
        "margin-left","margin-right","margin-top","margin-bottom"
      ].forEach(p => clearImp(left, p));

      restoreMargins();

      if (ph && ph.parentNode) ph.parentNode.removeChild(ph);
      ph = null;

      stuck = false;
      lastLeft = 0;
      lastW = 0;
    }

    function tick() {
      if (!isProductPage() || !isDesktop()) {
        if (stuck) reset();
        return;
      }

      const top = getTopOffset();
      const anchorRect = (ph ? ph.getBoundingClientRect() : left.getBoundingClientRect());
      const docTop = window.scrollY + anchorRect.top;

      // ✅ IMPORTANT: don’t pin at scrollY=0 (prevents that initial “gap” look)
      const startY = Math.max(docTop - top, 1);

      if (window.scrollY < startY) {
        if (stuck) reset();
        return;
      }

      if (!stuck) pin();

      updatePlaceholder();
      forceFixedMarginsOff();

      const pr = ph.getBoundingClientRect();
      if (Math.abs(pr.left - lastLeft) > 0.5) { setImp(left, "left", `${pr.left}px`); lastLeft = pr.left; }
      if (Math.abs(pr.width - lastW) > 0.5) { setImp(left, "width", `${pr.width}px`); lastW = pr.width; }

      const m = getStopMarker();
      if (m) {
        const stopTopDoc = window.scrollY + m.getBoundingClientRect().top - STOP_PAD;
        const h = left.offsetHeight;
        const endY = stopTopDoc - h - top;

        if (window.scrollY > endY) setImp(left, "top", `${top - (window.scrollY - endY)}px`);
        else setImp(left, "top", `${top}px`);
      } else {
        setImp(left, "top", `${top}px`);
      }
    }

    let raf = false;
    const onScroll = () => {
      if (raf) return;
      raf = true;
      requestAnimationFrame(() => { raf = false; tick(); });
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", () => requestAnimationFrame(() => { reset(); tick(); }));
    window.addEventListener("load", () => requestAnimationFrame(tick));

    tick();
    return true;
  }

  let tries = 0;
  const timer = setInterval(() => {
    tries++;
    if (boot() || tries >= 80) clearInterval(timer);
  }, 200);
})();
